module.exports = __webpack_public_path__ + "dontbicker.8cdefe38.png";